import React from 'react';
import { Col, Form, Input } from 'antd';



const CryptoForm = ({ setState, state, t }) => {
  const onChange = (e) => {
    const { name, value } = e.target;
    setState({ ...state, [name]: value });
  };
  return (
    <Col xxl={ 24 } lg={ 24 } md={ 24 } sm={ 24 } xs={ 24 }>
      <Form.Item
        label={t('Name of beneficiary')+':'}
        rules={ [
          {
            required: true,
            message: t('Please enter correct name of beneficiary'),
          },
        ] }
      >
        <Input name='name' onChange={ onChange } size="large" />
      </Form.Item>
      <Form.Item
        label={t('Email/Account/Phone')+':'}
      >
        <Input name='destinationAccount' onChange={ onChange } size="large" />
      </Form.Item>
    </Col>
  );
};
export default CryptoForm;